import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Seurat — Frisbeegolfradat' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Yhteisö"
			title="Seurat"
			intro="Suomen frisbeegolfseurat: liity mukaan paikalliseen toimintaan."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
